"use strict";
/**
 * Kalshi API Credentials Management
 * Handles API credentials storage and retrieval
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setApiCredentials = setApiCredentials;
exports.getApiCredentials = getApiCredentials;
exports.clearCredentials = clearCredentials;
exports.purgeLegacyStoredCredentials = purgeLegacyStoredCredentials;
// Global API credentials
let apiCredentials = null;
/**
 * Set API credentials for proxy requests
 * @param credentials - API credentials
 */
function setApiCredentials(credentials) {
    apiCredentials = credentials;
}
/**
 * Get current API credentials
 * @returns Current credentials or null
 */
function getApiCredentials() {
    return apiCredentials;
}
/**
 * Clear API credentials from memory (and purge any legacy persisted copy).
 *
 * SECURITY: credentials are kept in memory only. They used to be persisted
 * in sessionStorage ("kalshi_secret_key"), which any injected script could
 * read — that path was removed; the removeItem below cleans up copies left
 * behind by older versions of the app.
 */
function clearCredentials() {
    apiCredentials = null;
    purgeLegacyStoredCredentials();
}
/**
 * Remove the legacy sessionStorage copy of the secret, if present.
 * Safe to call unconditionally (e.g. at app startup).
 */
function purgeLegacyStoredCredentials() {
    try {
        sessionStorage.removeItem("kalshi_secret_key");
    }
    catch {
        // sessionStorage unavailable — nothing persisted, nothing to purge
    }
}
